import BaseApi from "../BaseApi";

export default class FormsApi extends BaseApi {

    construct() {}

    static getApiUrl() {
        return `${BaseApi.getApiVersionBasePath("v1")}forms`;
    }

    static async create(payload) {
        if(!payload) {
            throwOnRequiredArgument(this.name, "payload")
        }

        throwNotImplementedError(this.name);
    }

    static async createSubmission(formId, submission) {
        if(!formId ) {
            
            throwOnRequiredArgument(this.name, "formId")
        } else if(!submission) {
            throwOnRequiredArgument(this.name, "submission")
        }
        
        throwNotImplementedError(this.name);
    }

    static async submitFormSubmission(formCode, payload) {
        if(!formCode) {
            throwOnRequiredArgument(this.name, "formCode");
        } else if(!payload) {
            throwOnRequiredArgument(this.name, "payload");
        }

        return this.post(
            `${this.getApiUrl()}/${formCode}/submissions/`,
            payload
        )
    }

    static async getForm(formCode) {
        if(!formCode) {
            throwOnRequiredArgument(this.name, "formCode");
        }

        return this.get(`${this.getApiUrl()}/${formCode}`)
    }

    
    static async getFormSubmissions(formCode) {
        if(!formCode) {
            throwOnRequiredArgument(this.name, "formCode");
        }

        return this.get(`${this.getApiUrl()}/${formCode}/submissions`);
    }

    static async showFormSubmission(formCode, submissionId) {
        if(!formCode) {
            throwOnRequiredArgument(this.name, "formCode");
        } else if(!submissionId) {
            throwOnRequiredArgument(this.name, "submissionId");
        }

        return this.get(`${this.getApiUrl()}/${formCode}/submissions/${submissionId}`)
    }

    
    // method aliases
    static async indexSubmissions() {
        return this.get(`${this.getApiUrl()}/submissions`);
    }

    static async showForm(formCode) {
        return this.getForm(formCode);
    }

    static async indexForms() {
        return this.get(`${this.getApiUrl()}`);
    }

    static async indexFormSubmissions(formCode) {
        return this.getFormSubmissions(formCode);
    }

    static async createFormSubmission(formCode, payload) {
        return this.submitFormSubmission(formCode, payload);
    }
    
}